<template>
    <div class="job-wrapper flex-grow-1 d-flex flex-column">
        <vue-element-loading :active="loading" is-full-screen></vue-element-loading>
        <div class="tabs-wrapper flex-grow-1 d-flex flex-column" v-if="job.jobId">
            <portal to="sticky-header" :order="4">
                <div
                    class="title-wrapper navbar navbar-light navbar-expand bg-grey d-flex justify-content-between">
                    <h4 class="job-title"
                    >
                        {{ jobTitle }}
                    </h4>
                    <b-button
                            class="btn-arrow ml-4 py-1 d-none d-md-block"
                            variant="primary"
                            :to="{name: 'jobs'}"
                    >
                        Return to Jobs
                        <font-awesome-icon
                                :icon="['far', 'arrow-right']">
                        </font-awesome-icon>
                    </b-button>
                </div>
            </portal>
            <b-tabs
                class="tabs flex-grow-1 d-flex flex-column"
                :content-class="['bg-white d-flex flex-column flex-grow-1', {'sticky-footer': tabIndex < 2}]"
                active-tab-class="flex-grow-1 d-flex flex-column"
                nav-wrapper-class="d-none d-md-block"
                nav-class="flex-nowrap"
                v-model="tabIndex"
                @input="onTabShown"
                justified
            >
                <portal to="sticky-header" :order="5">
                    <scrollable-widget
                        arrow-bg-color="white"
                        class="tab-nav-wrapper d-block d-md-none pt-1 bg-white">
                        <b-nav justified class="d-flex flex-nowrap nav-tabs">
                            <b-nav-item
                                v-for="(tab, key) in tabs"
                                :key="key"
                                @click.prevent="tabIndex = key"
                                :active="tabIndex === key"
                                href="#"
                            >
                                {{ tab.title }}
                            </b-nav-item>
                        </b-nav>
                    </scrollable-widget>
                </portal>
                <b-tab
                    v-for="tab in tabs"
                    :key="tab.title"
                    :title="tab.title"
                >
                    <component
                        :is="tab.component"
                        :job="job"
                        :shown="tab.shown"
                        @update:loading="loading = $event"
                        v-on="tab.listeners"
                    >
                    </component>
                </b-tab>
            </b-tabs>
        </div>
    </div>
</template>

<script>
import Job from '@/services/Job/Job';
import JobPropertyGrid from '@/components/Job/JobPropertyGrid';
import JobRemovedPropertyGrid from '@/components/Job/JobRemovedPropertyGrid';
import ScrollableWidget from '@/components/Widgets/ScrollableWidget';

export default {
  name: 'Job-Page',
  components: {
    JobPropertyGrid,
    ScrollableWidget,
  },
  data() {
    return {
      tabIndex: 0,
      job: {},
      loading: false,
      tabs: [
        {
          title: 'Properties',
          shown: false,
          component: JobPropertyGrid,
        },
        {
          title: 'Removed',
          shown: false,
          component: JobRemovedPropertyGrid,
        },
      ],
    };
  },
  computed: {
    jobId() {
      return this.$route.params.jobId;
    },
    jobTitle() {
      return this.job.job;
    },
  },
  methods: {
    async fetch(jobId) {
      this.loading = true;
      this.job = {};

      try {
        const response = await Job.find(jobId);
        this.job = response.data.data;
      } catch (e) {
        this.$router.push({ name: 'jobs' }, () => {
          this.$notify({
            title: 'Job not found',
            text: 'Job could not be found.',
            type: 'error',
          });
        });
      } finally {
        this.loading = false;
      }
    },
    onTabShown(tabIndex) {
      this.tabs[tabIndex].shown = true;
    },
  },
  created() {
    this.fetch(this.jobId);

    this.$nextTick(() => {
      window.scrollTo(0, 0);
    });
  },
};
</script>

<style lang="scss" scoped>
    .job-wrapper {
        background: $gray;
    }

    .sticky-footer {
        .tab-pane {
            padding: 15px;

            /deep/ .form-body {
                overflow-y: scroll;
                height: calc(var(--window-height, 100vh) - calc(var(--sticky-header-height, 173px) + 85px + 15px));

                @include media-breakpoint-up(md) {
                    height: calc(var(--window-height, 100vh) - calc(var(--sticky-header-height, 222px) + 85px + 15px));
                }
            }
        }
    }

    .job-title {
        margin-top: map_get($spacers, 2);
    }

    @include media-breakpoint-down(sm) {
        .job-title {
            margin-top: 0;
            font-size: 1rem;
            font-weight: bold;
            margin-bottom: 0;
        }
    }
</style>
